import {
  AvailableIntegrationsDocument,
  IntegrationsCapabilityTypeEnum,
  MarketplaceDbIntegration,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useAvailableIntegration = (
  capabilityType: IntegrationsCapabilityTypeEnum
): MarketplaceDbIntegration | null => {
  const { data } = useQuery(AvailableIntegrationsDocument, {
    variables: {
      capabilityType,
    },
  })

  return (
    data?.integrations?.availableIntegrationsConnection.nodes[0]?.marketplaceIntegration ?? null
  )
}
